







import { Component, Emit, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class App extends Vue {
  @Emit("plus") plus() {
    console.log("plus");
  }

  @Emit("min") min() {
    console.log("close");
  }
}
